// extracted by mini-css-extract-plugin
module.exports = {"label":"k0o22KfL_vWU8vROwTD7c","active":"_3AZS_880O2_78V8nU_aa5f"};